import React, { FC } from 'react';
import { HeaderModel } from '../../../models/CommonModel';
import SortableColumn from '../../../components/Table/SortableColumn';
import { formatPrice } from '../../../selectors';
import { PaymentRowModel } from '../../../models/account-books/PaymentAccount';
import moment from 'moment';

type Props = {
    data: Array<PaymentRowModel>,
    selected: number[]
    setSelected: (ids: number[]) => void
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};

const BankBookAccountTable: FC<Props> = ({ data, selected, setSelected, header, hideCols, openColConfig, handleSort }) => {
    const allSelected = data.length > 0 && data.every((item) => selected.includes(item.id));

    const toggleCheckAll = (checked: boolean) => {
        const next = new Set<number>(selected);
        const dataIds = data.map((el) => el.id);

        if (checked) {
            dataIds.forEach((id) => next.add(id));
        } else {
            dataIds.forEach((id) => next.delete(id));
        }

        setSelected(Array.from(next));
    };

    const toggleSelected = (item: PaymentRowModel, checked: boolean) => {
        const next = new Set<number>(selected);

        if (checked) {
            next.add(item.id);
        } else {
            next.delete(item.id);
        }

        setSelected(Array.from(next));
    };
    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <input
                                className="me-2 form-check-input"
                                type="checkbox"
                                checked={allSelected}
                                onChange={(e) => toggleCheckAll(e.target.checked)}
                            />
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: PaymentRowModel, index: number) => {
                        let inAmount: any = formatPrice(item.amount ?? 0);
                        let outAmount: any = '';
                        if (item.direction === 'out') {
                            inAmount = '';
                            outAmount = formatPrice(item.amount ?? 0);
                        }
                        const checked = selected.includes(item.id);
                        const isDeteled = item.deleted_at !== null;
                        return (
                            <tr key={`bank_${index}`} className={"cursor-pointer" + (isDeteled ? ' bg-light text-decoration-line-through text-muted' : '')}>
                                <td>
                                    <input
										className="form-check-input"
										type="checkbox"
										checked={checked}
                                        disabled={isDeteled}
										onChange={(e) => toggleSelected(item, e.target.checked)}
									/>
                                </td>
                                {!hideCols.includes('posting_date') && (
                                <td>
                                    {moment(item.posting_date).format('DD-MM-YYYY')}
                                </td>
                                )}
                                {!hideCols.includes('voucher_no') && (
                                <td>{item?.voucher_no ?? ''}</td>
                                )}
                                {!hideCols.includes('in_amount') && (
                                <td style={{textAlign: "right"}}>{inAmount}</td>
                                )}
                                {!hideCols.includes('out_amount') && (
                                <td style={{textAlign: "right"}}>{outAmount}</td>
                                )}
                                {!hideCols.includes('description') && (
                                <td >{item.description}</td>
                                )}
                                <td >
                                    {isDeteled && (
                                        <span className='badge bg-secondary disabled text-muted'>Đã xóa</span>
                                    )}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default BankBookAccountTable;